// extracted by mini-css-extract-plugin
module.exports = {"tab_content":"tab_content-1oA6sbgL","content":"content-3HCGiTSh"};